module.exports = __webpack_public_path__ + "img/signup_bg_webapp_2.40bd97a4.png";